import React from 'react'
import grn from '../Assets/green_bg.png'
import red from '../Assets/red_bg.png'

const K3Ball = ({ addBall, i }) => {
  return (
    <div onClick={() => addBall(i)} className='flex flex-col justify-center items-center'>

    <div className='relative w-[35px] h-[35px] bg-gray-300 rounded-full cursor-pointer flex justify-center items-center'>
        <p className={`text-center `}>{i}</p>
    </div>
       <p className='text-black '>9</p>
    </div>
  )
}

export default K3Ball